package ui.components.atoms

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*

@Composable
fun PrimaryButton(
    text: String,
    onClick: () -> Unit,
    disabled: Boolean = false,
    variant: ButtonVariant = ButtonVariant.Primary
) {
    Button(
        attrs = {
            onClick { if (!disabled) onClick() }
            if (disabled) disabled()
            classes("btn", "btn-${variant.name.lowercase()}")
            style {
                if (disabled) {
                    opacity(0.6)
                    cursor("not-allowed")
                } else {
                    cursor("pointer")
                }
            }
        }
    ) {
        Text(text)
    }
}

@Composable
fun IconButton(
    icon: String,
    onClick: () -> Unit,
    disabled: Boolean = false,
    title: String? = null
) {
    Button(
        attrs = {
            onClick { if (!disabled) onClick() }
            if (disabled) disabled()
            title?.let { title(it) }
            classes("btn", "btn-icon")
            style {
                if (disabled) {
                    opacity(0.6)
                    cursor("not-allowed")
                } else {
                    cursor("pointer")
                }
            }
        }
    ) {
        Text(icon)
    }
}

enum class ButtonVariant {
    Primary,
    Secondary,
    Danger,
    Success
}